export const translations = {
  ro: {
    nav: {
      about: "Despre",
      services: "Servicii",
      work: "Lucrări",
      process: "Proces",
      contact: "Contact",
      cta: "Solicită ofertă",
    },
    hero: {
      eyebrow: "Castel Construct · Est. 2019 · Chișinău",
      titleA: "Construim",
      titleB: "un viitor",
      titleC: "frumos.",
      lead: "Cu o experiență de peste 5 ani și un accent real pe satisfacția clienților, vă puteți baza pe noi pentru fundații de turbine eoliene, sisteme de membrane CARLISLE® și lucrări de terasament.",
      ctaPrimary: "Începe un proiect",
      ctaSecondary: "Servicii",
    },
    marquee: ["Fundații Eoliene", "Membrane CARLISLE®", "Terasamente", "La cheie", "Calitate", "Termen"],
    about: {
      eyebrow: "Despre",
      title: "Un meșteșug răbdător într-o lume grăbită.",
      body:
        "Fondată în 2019 în Goian, municipiul Chișinău, Castel Construct SRL execută lucrări de construcții civile și industriale cu o exigență ce nu se negociază. Echipa noastră tratează fiecare șantier ca pe un proiect personal — de la primul plan la cheia predată clientului.",
      values: [
        { num: "01", title: "Inovație", body: "Tehnică modernă, soluții potrivite contextului — nu copy-paste." },
        { num: "02", title: "Calitate", body: "Materiale verificate. Toleranțe stricte. Detalii care rezistă timpului." },
        { num: "03", title: "Transparență", body: "Bugete clare, rapoarte săptămânale, comunicare directă pe tot parcursul." },
      ],
    },
    services: {
      eyebrow: "Servicii",
      title: "Trei capabilități. Un singur standard.",
      items: [
        {
          tag: "01 / Energie eoliană",
          title: "Fundații pentru turbine eoliene",
          body: "Executăm fundații specializate pentru turbine eoliene, conform cerințelor tehnice și standardelor de inginerie ale producătorilor.",
        },
        {
          tag: "02 / Hidroizolații",
          title: "Sisteme de membrane CARLISLE®",
          body: "Aplicare profesională a sistemelor de membrane CARLISLE® pentru acoperișuri și hidroizolații — soluție durabilă, testată în timp.",
        },
        {
          tag: "03 / Terasamente",
          title: "Lucrări de terasament",
          body: "Pregătirea terenului, săpături, nivelări și amenajări preliminare. Sigur, curat, la timp.",
        },
      ],
    },
    portfolio: {
      eyebrow: "Proiecte",
      title: "Lucrări recente.",
      items: [
        { name: "Castel Construct SRL", type: "Proiect finisat cu succes", year: "Mai 2025" },
        { name: "Townhouse în 3 nivele", type: "Str. Dumbrăviței, Hrușova, Criuleni", year: "Mai 2025" },
      ],
    },
    process: {
      eyebrow: "Proces",
      title: "Patru pași, fără surprize.",
      steps: [
        { num: "01", title: "Consultație", body: "Discuție inițială, vizita pe teren, briefing detaliat al nevoilor." },
        { num: "02", title: "Proiectare", body: "Soluții tehnice, vizualizări, deviz transparent și calendar de execuție." },
        { num: "03", title: "Execuție", body: "Șantier organizat, raportare săptămânală, control de calitate la fiecare etapă." },
        { num: "04", title: "Predare", body: "Verificare finală, recepție formală, garanție și suport post-livrare." },
      ],
    },
    team: {
      eyebrow: "Echipă",
      title: "Oamenii din spatele structurilor.",
      placeholder: "Pagina echipei vine în curând.",
    },
    testimonials: {
      eyebrow: "Mărturii",
      title: "Ce spun clienții.",
      placeholder: "Mărturiile clienților vor fi publicate în curând.",
    },
    contact: {
      eyebrow: "Contact",
      title: "Hai să construim ceva bun.",
      lead: "Trimite-ne câteva detalii despre proiectul tău. Revenim cu o ofertă în 48 de ore.",
      form: {
        name: "Nume",
        email: "Email",
        phone: "Telefon",
        message: "Despre proiect",
        submit: "Trimite cererea",
        success: "Mesajul tău a fost transmis. Revenim curând.",
      },
      info: {
        phone: "Telefon",
        email: "Email",
        address: "Adresă",
        hours: "Program",
        hoursValue: "Luni — Vineri · 09:00 — 18:00",
      },
    },
    footer: {
      cta: "Pregătit să începem?",
      ctaSub: "Spune-ne ce ai în minte.",
      rights: "Toate drepturile rezervate.",
      links: { home: "Acasă", services: "Servicii", projects: "Proiecte", about: "Despre noi", contact: "Contact" },
    },
  },
  en: {
    nav: { about: "About", services: "Services", work: "Work", process: "Process", contact: "Contact", cta: "Request quote" },
    hero: {
      eyebrow: "Castel Construct · Est. 2019 · Chișinău",
      titleA: "Building",
      titleB: "a beautiful",
      titleC: "future.",
      lead: "With over 5 years of experience and a real focus on client satisfaction, count on us for wind turbine foundations, CARLISLE® membrane systems and earthworks.",
      ctaPrimary: "Start a project",
      ctaSecondary: "Services",
    },
    marquee: ["Wind Foundations", "CARLISLE® Membranes", "Earthworks", "Turnkey", "Quality", "On time"],
    about: {
      eyebrow: "About",
      title: "Patient craft in a hurried world.",
      body:
        "Founded in 2019 in Goian, Chișinău, Castel Construct SRL executes civil and industrial works to a non-negotiable standard. We treat every site as our own — from the first sketch to the handed-over key.",
      values: [
        { num: "01", title: "Innovation", body: "Modern technique, context-aware solutions — never copy-paste." },
        { num: "02", title: "Quality", body: "Vetted materials. Tight tolerances. Details that age well." },
        { num: "03", title: "Transparency", body: "Clear budgets, weekly reports, direct communication throughout." },
      ],
    },
    services: {
      eyebrow: "Services",
      title: "Three capabilities. One standard.",
      items: [
        { tag: "01 / Wind energy", title: "Wind turbine foundations", body: "Specialised foundations for wind turbines, built to manufacturer engineering standards and technical requirements." },
        { tag: "02 / Waterproofing", title: "CARLISLE® membrane systems", body: "Professional installation of CARLISLE® membrane systems for roofing and waterproofing — a proven, long-lasting solution." },
        { tag: "03 / Earthworks", title: "Earthworks", body: "Site preparation, excavation, levelling and preliminary works. Safe, clean, on time." },
      ],
    },
    portfolio: {
      eyebrow: "Projects",
      title: "Recent work.",
      items: [
        { name: "Castel Construct SRL", type: "Project successfully delivered", year: "May 2025" },
        { name: "3-level townhouse", type: "Dumbrăviței St., Hrușova, Criuleni", year: "May 2025" },
      ],
    },
    process: {
      eyebrow: "Process",
      title: "Four steps, zero surprises.",
      steps: [
        { num: "01", title: "Consultation", body: "Initial discussion, site visit, detailed brief of needs." },
        { num: "02", title: "Design", body: "Technical solutions, visuals, transparent estimate and timeline." },
        { num: "03", title: "Execution", body: "Organised site, weekly reporting, quality control at each stage." },
        { num: "04", title: "Handover", body: "Final check, formal acceptance, warranty and post-delivery support." },
      ],
    },
    team: { eyebrow: "Team", title: "The people behind the structures.", placeholder: "The team page is coming soon." },
    testimonials: { eyebrow: "Testimonials", title: "What clients say.", placeholder: "Client testimonials will be published soon." },
    contact: {
      eyebrow: "Contact",
      title: "Let's build something good.",
      lead: "Send us a few details about your project. We'll come back with an estimate in 48 hours.",
      form: { name: "Name", email: "Email", phone: "Phone", message: "About the project", submit: "Send request", success: "Your message is on the way. We'll be in touch shortly." },
      info: { phone: "Phone", email: "Email", address: "Address", hours: "Hours", hoursValue: "Mon — Fri · 09:00 — 18:00" },
    },
    footer: {
      cta: "Ready to start?",
      ctaSub: "Tell us what you have in mind.",
      rights: "All rights reserved.",
      links: { home: "Home", services: "Services", projects: "Projects", about: "About", contact: "Contact" },
    },
  },
  ru: {
    nav: { about: "О нас", services: "Услуги", work: "Работы", process: "Процесс", contact: "Контакты", cta: "Запросить смету" },
    hero: {
      eyebrow: "Castel Construct · с 2019 · Кишинёв",
      titleA: "Строим",
      titleB: "красивое",
      titleC: "будущее.",
      lead: "С опытом более 5 лет и реальным акцентом на удовлетворённости клиентов вы можете положиться на нас в фундаментах под ветрогенераторы, системах мембран CARLISLE® и земляных работах.",
      ctaPrimary: "Начать проект",
      ctaSecondary: "Услуги",
    },
    marquee: ["Фундаменты ВЭУ", "Мембраны CARLISLE®", "Земляные работы", "Под ключ", "Качество", "В срок"],
    about: {
      eyebrow: "О нас",
      title: "Терпеливое ремесло в мире спешки.",
      body:
        "Основана в 2019 году в Гоянах, муниципий Кишинёв. Castel Construct SRL выполняет гражданские и промышленные работы без компромиссов. Мы относимся к каждой площадке как к своей собственной — от первого эскиза до сданного ключа.",
      values: [
        { num: "01", title: "Инновации", body: "Современная техника, решения по контексту — без шаблонов." },
        { num: "02", title: "Качество", body: "Проверенные материалы. Жёсткие допуски. Детали, выдерживающие время." },
        { num: "03", title: "Прозрачность", body: "Понятные бюджеты, еженедельные отчёты, прямая связь на всех этапах." },
      ],
    },
    services: {
      eyebrow: "Услуги",
      title: "Три направления. Один стандарт.",
      items: [
        { tag: "01 / Ветроэнергетика", title: "Фундаменты под ветрогенераторы", body: "Специализированные фундаменты для ветрогенераторов в соответствии с техническими требованиями и инженерными стандартами производителей." },
        { tag: "02 / Гидроизоляция", title: "Системы мембран CARLISLE®", body: "Профессиональный монтаж систем мембран CARLISLE® для кровли и гидроизоляции — проверенное долговечное решение." },
        { tag: "03 / Земляные работы", title: "Земляные работы", body: "Подготовка площадки, выемка грунта, планировка и предварительные работы. Безопасно, чисто, в срок." },
      ],
    },
    portfolio: {
      eyebrow: "Проекты",
      title: "Последние работы.",
      items: [
        { name: "Castel Construct SRL", type: "Успешно сданный проект", year: "Май 2025" },
        { name: "Таунхаус в 3 уровня", type: "Ул. Думбрэвицей, Хрушова, Криуляны", year: "Май 2025" },
      ],
    },
    process: {
      eyebrow: "Процесс",
      title: "Четыре шага, без сюрпризов.",
      steps: [
        { num: "01", title: "Консультация", body: "Первая встреча, выезд на участок, детальный бриф." },
        { num: "02", title: "Проектирование", body: "Технические решения, визуализации, прозрачная смета и график." },
        { num: "03", title: "Исполнение", body: "Организованная стройка, еженедельные отчёты, контроль качества." },
        { num: "04", title: "Сдача", body: "Финальная проверка, приёмка, гарантия и пост-сопровождение." },
      ],
    },
    team: { eyebrow: "Команда", title: "Люди за стенами и плитами.", placeholder: "Страница команды скоро появится." },
    testimonials: { eyebrow: "Отзывы", title: "Что говорят клиенты.", placeholder: "Отзывы клиентов скоро будут опубликованы." },
    contact: {
      eyebrow: "Контакты",
      title: "Давайте построим что-то хорошее.",
      lead: "Отправьте несколько деталей о проекте. Вернёмся со сметой в течение 48 часов.",
      form: { name: "Имя", email: "Email", phone: "Телефон", message: "О проекте", submit: "Отправить заявку", success: "Сообщение отправлено. Скоро свяжемся." },
      info: { phone: "Телефон", email: "Email", address: "Адрес", hours: "Часы", hoursValue: "Пн — Пт · 09:00 — 18:00" },
    },
    footer: {
      cta: "Готовы начать?",
      ctaSub: "Расскажите, что у вас на уме.",
      rights: "Все права защищены.",
      links: { home: "Главная", services: "Услуги", projects: "Проекты", about: "О нас", contact: "Контакты" },
    },
  },
};
